/**
 * Aviso de cookies (LGPD) — porte de lp-lancamento/lp.js › montarCookies().
 *
 * O Consent Mode já nasce negado no <head> (snippets/yasy-consent.liquid),
 * antes do GTM. Aqui só se mostra o aviso, se registra a escolha e se avisa o
 * Google dela. Recusar depois de ter aceitado também apaga os cookies do GA
 * que já tinham sido gravados — revogar precisa ser tão fácil quanto aceitar.
 *
 * Carregado pelo snippets/yasy-cookies.liquid, que traz o aviso em si.
 */
(function () {
  var CHAVE = 'yasy-cookies';

  function lerEscolha() {
    try {
      return localStorage.getItem(CHAVE);
    } catch (erro) {
      return null;
    }
  }

  function apagarCookiesAnalise() {
    var partes = window.location.hostname.split('.');
    /* O GA grava no domínio raiz (.yasy.com.br), mas pode ter ficado no host
       também: tenta os dois. */
    var dominios = ['', window.location.hostname];
    for (var i = 1; i < partes.length - 1; i += 1) {
      dominios.push('.' + partes.slice(i).join('.'));
    }

    document.cookie.split(';').forEach(function (par) {
      var nome = par.split('=')[0].trim();
      if (!/^(_ga|_gid|_gat|_fbp|_fbc)/.test(nome)) return;
      dominios.forEach(function (dominio) {
        var alvo = dominio ? '; domain=' + dominio : '';
        document.cookie = nome + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + alvo;
      });
    });
  }

  /* Repassa a escolha à Shopify. Os pixels de Eventos do cliente (inclusive o
     do checkout, que não carrega este tema) só obedecem ao consentimento que a
     Shopify conhece, não ao localStorage deste aviso. */
  function avisarShopify(aceitou) {
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') return;
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (erro) {
      if (erro || !shopify.customerPrivacy) return;
      shopify.customerPrivacy.setTrackingConsent(
        { analytics: aceitou, marketing: aceitou, preferences: aceitou, sale_of_data: aceitou },
        function () {}
      );
    });
  }

  /* Quem escolheu antes desta sincronização existir: a Shopify ainda não sabe.
     Só repassa quando ela não tem escolha registrada, para não gravar à toa. */
  function sincronizarEscolhaAntiga() {
    var escolha = lerEscolha();
    var shopify = window.Shopify;
    if (!escolha || !shopify || typeof shopify.loadFeatures !== 'function') return;
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (erro) {
      if (erro || !shopify.customerPrivacy) return;
      var atual = shopify.customerPrivacy.currentVisitorConsent();
      if (atual && atual.analytics) return;
      avisarShopify(escolha === 'aceito');
    });
  }

  function montar() {
    var aviso = document.querySelector('[data-yasy-cookies]');
    if (!aviso) return;

    var mostrar = function () {
      aviso.hidden = false;
      var aceitar = aviso.querySelector('[data-cookies="aceito"]');
      if (aceitar) aceitar.focus({ preventScroll: true });
    };

    if (!lerEscolha()) aviso.hidden = false;

    aviso.addEventListener('click', function (evento) {
      var botao = evento.target.closest('[data-cookies]');
      if (!botao) return;

      var escolha = botao.dataset.cookies;
      try {
        localStorage.setItem(CHAVE, escolha);
      } catch (erro) {
        /* Sem storage a escolha vale só para esta visita. */
      }

      var aceitou = escolha === 'aceito';
      var estado = aceitou ? 'granted' : 'denied';
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          analytics_storage: estado,
          ad_storage: estado,
          ad_user_data: estado,
          ad_personalization: estado
        });
      }
      avisarShopify(aceitou);
      if (!aceitou) apagarCookiesAnalise();

      aviso.hidden = true;
    });

    /* "Preferências de cookies" (rodapé e formulário) reabre o aviso. */
    document.querySelectorAll('[data-abrir-cookies]').forEach(function (gatilho) {
      if (gatilho.dataset.yasyCookiesLigado) return;
      gatilho.dataset.yasyCookiesLigado = 'sim';
      gatilho.addEventListener('click', mostrar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
  sincronizarEscolhaAntiga();
  /* O Theme Editor recarrega seções sem recarregar a página: o botão de
     preferências pode nascer depois. */
  document.addEventListener('shopify:section:load', montar);
})();
